export default "__VITE_ASSET__60201e11__"